exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-service[data-v-3126a234]{position:fixed;bottom:150px;right:70px;z-index:2000}.customer-service .svg-icon[data-v-3126a234]{font-size:50px;border-radius:50%;background:#fff}\n", ""]);

// exports
